import api from '@/services/api';

export default {
  async get(settingsTemplateId) {
    try {
      let response = await api.get(`SettingsTemplates/${settingsTemplateId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getAll(includeArchived) {
    try {
      let response = await api.get(`SettingsTemplates?includeArchived=${includeArchived}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getDropdown() {
    try {
      let response = await api.get(`SettingsTemplates/Dropdown`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async copyTemplate(settingsTemplateId) {
    try {
      let response = await api.post(`SettingsTemplates/${settingsTemplateId}/Copy`);
      if (response && response.status == 200 && response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false, data: (response && response.error) ? response.error : 'Unable to copy template' };
      }
    } catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  },
  async create(settingsTemplate) {
    try {
      let requestBody = {
        name: settingsTemplate.name,

        estimateFutureHistoricalsOption: settingsTemplate.estimateFutureHistoricalsOption,
        estimateFutureHistoricalOptionMonthOption: settingsTemplate.estimateFutureHistoricalOptionMonthOption,
        increaseOverExistingRentAmount: settingsTemplate.increaseOverExistingRentAmount,
        increaseOverExistingRentDenomination: settingsTemplate.increaseOverExistingRentDenomination,
        discountMarketRentPercentage: settingsTemplate.discountMarketRentPercentage,
        newLeaseCalculationOption: settingsTemplate.newLeaseCalculationOption,
        renewalPricingCalculationOption: settingsTemplate.renewalPricingCalculationOption,
        newRecurringConcessionMarketRentPercentage: settingsTemplate.newRecurringConcessionMarketRentPercentage,
        renewalRecurringConcessionMarketRentPercentage: settingsTemplate.renewalRecurringConcessionMarketRentPercentage,
        newRecurringConcessionTransactionCategoryId: (settingsTemplate.newRecurringConcessionTransactionCategoryId && settingsTemplate.newRecurringConcessionTransactionCategoryId.value),
        renewalRecurringConcessionTransactionCategoryId: (settingsTemplate.renewalRecurringConcessionTransactionCategoryId && settingsTemplate.renewalRecurringConcessionTransactionCategoryId.value),
        otherConcessionTransactionCategories: (settingsTemplate.otherConcessionTransactionCategories && settingsTemplate.otherConcessionTransactionCategories.map((cat) => { return cat.value })) || [],
        badDebtOption: settingsTemplate.badDebtOption,
        badDebtGLAccount: (settingsTemplate.badDebtGLAccount && settingsTemplate.badDebtGLAccount.value),
        badDebtGLPercentage: settingsTemplate.badDebtGLPercentage,
        BadDebtTransactionCategoryId: (settingsTemplate.badDebtTransactionCategoryId && settingsTemplate.badDebtTransactionCategoryId.value),

        approvalWorkflowId: settingsTemplate.approvalWorkflowId || null
      };
      let response = await api.post('SettingsTemplates', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async update(settingsTemplateId, settingsTemplate) {
    try {
      let requestBody = {
        settingsTemplateId: settingsTemplateId,

        name: settingsTemplate.name,

        estimateFutureHistoricalsOption: settingsTemplate.estimateFutureHistoricalsOption,
        estimateFutureHistoricalOptionMonthOption: settingsTemplate.estimateFutureHistoricalOptionMonthOption,
        increaseOverExistingRentAmount: settingsTemplate.increaseOverExistingRentAmount,
        increaseOverExistingRentDenomination: settingsTemplate.increaseOverExistingRentDenomination,
        discountMarketRentPercentage: settingsTemplate.discountMarketRentPercentage,
        newLeaseCalculationOption: settingsTemplate.newLeaseCalculationOption,
        renewalPricingCalculationOption: settingsTemplate.renewalPricingCalculationOption,
        newRecurringConcessionMarketRentPercentage: settingsTemplate.newRecurringConcessionMarketRentPercentage,
        renewalRecurringConcessionMarketRentPercentage: settingsTemplate.renewalRecurringConcessionMarketRentPercentage,
        newRecurringConcessionTransactionCategoryId: (settingsTemplate.newRecurringConcessionTransactionCategoryId && settingsTemplate.newRecurringConcessionTransactionCategoryId.value),
        renewalRecurringConcessionTransactionCategoryId: (settingsTemplate.renewalRecurringConcessionTransactionCategoryId && settingsTemplate.renewalRecurringConcessionTransactionCategoryId.value),
        otherConcessionTransactionCategories: (settingsTemplate.otherConcessionTransactionCategories && settingsTemplate.otherConcessionTransactionCategories.map((cat) => { return cat.value })),
        badDebtOption: settingsTemplate.badDebtOption,
        badDebtGLAccount: settingsTemplate.badDebtGLAccount && settingsTemplate.badDebtGLAccount.value,
        badDebtGLPercentage: settingsTemplate.badDebtGLPercentage,
        BadDebtTransactionCategoryId: settingsTemplate.badDebtTransactionCategoryId && settingsTemplate.badDebtTransactionCategoryId.value,

        approvalWorkflowId: settingsTemplate.approvalWorkflowId || null,

        lastModifiedTimestamp: settingsTemplate.lastModifiedTimestamp
      };
      let response = await api.put('SettingsTemplates', requestBody);
      if (response && response.status == 200 && response.data) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async updateIsArchived(settingsTemplateId, isArchived, lastModifiedTimestamp) {
    try {
      let requestBody = {
        settingsTemplateId: settingsTemplateId,
        newIsArchived: isArchived,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.put('SettingsTemplates/UpdateIsArchived', requestBody);
      if (response && response.status == 200 && response.data) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  }
}
